import { SET_AGENT_CONTEXT, FORGET_AGENT_CONTEXT } from 'agent_portal/actions/AgentContextActions';

const initialState = {
  type: undefined,
  id: undefined,
};

export default function agentContext(state = initialState, action) {
  switch (action.type) {
    case SET_AGENT_CONTEXT:
      return Object.assign({}, state, {
        type: action.contextType,
        id: action.contextId,
      });

    case FORGET_AGENT_CONTEXT:
      return initialState;

    default:
      return state;
  }
}
